var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.frame)?_c('div',{staticClass:"textbox-tag"},[_c('div',{ref:"textContent",staticClass:"textbox",class:_vm.sizeClz,style:([_vm.styleObj]),domProps:{"innerHTML":_vm._s(_vm.rawHtml)},on:{"click":_vm.onClick}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }